import React from 'react';
import css from './MainLandingPage.module.css';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import AlternativeHero from './components/AlternativeHero/AlternativeHero';
import GearMarketplaceSection from './components/GearMarketplaceSection/GearMarketplaceSection';
import GymDirectorySection from './components/GymDirectorySection/GymDirectorySection';
import CTACardsSection from './components/CTACardsSection/CTACardsSection';
import MissionSection from './components/MissionSection/MissionSection';
import BlogSection from './components/BlogSection/BlogSection';
import TestimonialsSection from './components/TestimonialsSection/TestimonialsSection';
import Footer from './components/Footer/Footer';

const MainLandingPageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <Page title={'Grounddz - Martial Arts Marketplace'} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<Footer />}>
        <div className={css.wrapper}>
          <AlternativeHero />
          <GearMarketplaceSection />
          <GymDirectorySection />
          <CTACardsSection />
          <MissionSection />
          <BlogSection />
          <TestimonialsSection />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const MainLandingPage = compose(connect(mapStateToProps))(MainLandingPageComponent);

export default MainLandingPage;

